import { jsxs as i, jsx as e } from "react/jsx-runtime";
import y from "../../../assets/svg/IconSetting.js";
import { Input as C } from "../../../components/ui/input.js";
import g from "../../../components/ui/switchWithText.js";
import R from "../../../store/useStore.js";
import { useNotify as T } from "../../../hooks/useNotify.js";
import { cn as m } from "../../../lib.js";
import k from "../../../hooks/useScreen.js";
import j from "../../../assets/svg/IconRemove.js";
import "react";
import "../../../extend-tailwind-merge-e63b2b56.js";
import "../../../_commonjsHelpers-10dfc225.js";
import "../../../index-9d43cc8b.js";
import "../../../store/createTokenSearchSlice.js";
import "../../../immer-548168ec.js";
import "../../../store/createWalletSlice.js";
import "../../../store/createSwapSettingsSlice.js";
import "../../../store/createGlobalSettingsSlice.js";
import "../../../store/createUserOrdersSlice.js";
import "../../../store/createSwapSlice.js";
import "../../../store/createChartSlice.js";
import "../../../store/createBasketSlice.js";
import "../tokens.js";
import "../../../store/createModalWhatsNewSlice.js";
import "../../../store/createSwapParamsSlice.js";
import "../../../react-toastify.esm-a636d9b1.js";
import "../../../assets/svg/IconCopy.js";
import "../../../assets/svg/IconX.js";
import "../../../assets/svg/IconCheckNotify.js";
import "../../../assets/svg/IconAlertTriangleNotify.js";
import "../../../assets/svg/IconArrowUpRightNotify.js";
const oe = () => {
  const {
    isDexSplitting: x,
    localRouting: u,
    slippage: d,
    isCustomSlippage: t,
    isOpenSwapSetting: n,
    isAutomaticSlippage: l,
    setSlippage: p,
    setIsCustomSlippage: f,
    setIsOpenSwapSetting: r,
    setIsAutomaticSlippage: S
  } = R((s) => s.swapSettingsSlice), { notify: h } = T(), { isMobile: v } = k(), b = () => {
    if (f(!t), t) {
      p(2), o({ slippage: 2, isCustomSlippage: !t });
      return;
    }
    o({
      isCustomSlippage: !t,
      slippage: d
    });
  }, c = (s) => {
    const a = Number(s.target.value);
    if (s.target.value.startsWith("0") && !s.target.value.startsWith("0.") && (s.target.value = s.target.value.replace(/^0+/, "")), a > 500) {
      p(500), o({ slippage: 500 }), h({
        type: "warning",
        title: "Slippage saved",
        desc: "Slippage tolerance is set to 500%"
      });
      return;
    }
    a > 10 && h({
      type: "warning",
      title: "Slippage saved",
      desc: `Slippage tolerance is set to ${a}%`
    }), p(a), o({ slippage: a });
  }, w = (s) => {
    if (s.key === "s") {
      r(!n);
      return;
    }
  }, N = (s) => {
    if (s) {
      p(-1), o({ slippage: -1 }), h({
        type: "warning",
        title: "Slippage saved",
        desc: "Slippage tolerance is set to unlimited"
      });
      return;
    }
    p(2), o({ slippage: 2 });
  }, o = (s) => {
    const a = {
      isDexSplitting: x,
      localRouting: u,
      slippage: d,
      isCustomSlippage: t,
      ...s
    };
    localStorage.setItem("swapSettings", JSON.stringify(a));
  };
  return /* @__PURE__ */ i("div", { className: "dhs-bg-background dhs-px-7 dhs-p-[10px] dhs-rounded-[26px] dhs-h-[406px] @sm/appRoot:dhs-h-[482px] dhs-w-full dhs-fade-in-right", children: [
    /* @__PURE__ */ i("div", { className: "dhs-flex dhs-justify-between dhs-gap-2 dhs-items-center @sm/appRoot:dhs-py-3 dhs-pb-2", children: [
      /* @__PURE__ */ e(
        "div",
        {
          className: "dhs-flex dhs-gap-4 dhs-items-center",
          onClick: () => r(!n),
          children: /* @__PURE__ */ e(
            y,
            {
              fontSize: 22,
              className: "dhs-text-mainText dhs-cursor-pointer"
            }
          )
        }
      ),
      /* @__PURE__ */ e("span", { className: "dhs-text-mainText sm:dhs-text-md dhs-text-lg dhs-font-proximaSemiBold", children: "Settings" }),
      /* @__PURE__ */ e(
        "div",
        {
          onClick: () => r(!n),
          className: "dhs-flex dhs-justify-center dhs-items-center dhs-w-8 dhs-h-8 dhs-rounded-xl dhs-bg-containers dhs-cursor-pointer",
          children: /* @__PURE__ */ e(j, { className: "dhs-text-mainText dhs-flex dhs-w-[12px] dhs-h-[12px]" })
        }
      )
    ] }),
    /* @__PURE__ */ i("div", { className: "dhs-flex dhs-flex-col dhs-mt-2 dhs-items-start @md/appRoot:dhs-gap-5 dhs-gap-2 dhs-justify-between @sm/appRoot:dhs-py-2", children: [
      /* @__PURE__ */ e("div", { className: "dhs-flex dhs-flex-col dhs-w-full", children: /* @__PURE__ */ i("div", { className: "dhs-flex dhs-justify-between dhs-items-center", children: [
        /* @__PURE__ */ i("span", { className: "dhs-text-mainText dhs-font-proximaSemiBold dhs-text-lg dhs-leading-none dhs-flex dhs-flex-col @sm/appRoot:dhs-gap-1", children: [
          /* @__PURE__ */ e("span", { children: "Slippage tolerance" }),
          /* @__PURE__ */ e(
            "span",
            {
              className: "dhs-underline dhs-underline-offset-4 dhs-decoration-accent dhs-text-subText dhs-font-proximaBold dhs-text-sm dhs-cursor-pointer hover:dhs-text-accent",
              onClick: () => window.open(
                "https://www.investopedia.com/terms/s/slippage.asp#:~:text=Slippage%20occurs%20when%20the%20bid,bonds%2C%20currencies%2C%20and%20futures.",
                "_blank"
              ),
              children: /* @__PURE__ */ e("a", { href: "", children: "Learn more" })
            }
          )
        ] }),
        /* @__PURE__ */ e(
          g,
          {
            left: "AUTO",
            right: "CUSTOM",
            className: "@md/appRoot:dhs-w-[148px] @md/appRoot:dhs-h-[40px] dhs-w-[110px]",
            initValue: t,
            onChange: b
          }
        )
      ] }) }),
      /* @__PURE__ */ i("div", { className: "dhs-flex dhs-items-center dhs-mb-1 @sm/appRoot:dhs-bg-inherit", children: [
        /* @__PURE__ */ e("div", { className: "dhs-flex dhs-gap-[7px] dhs-mr-[7px]", children: ["0.5", "1", "2", "5"].map((s) => /* @__PURE__ */ e(
          "div",
          {
            className: m(
              "dhs-flex dhs-items-center dhs-justify-center dhs-w-10 @md/appRoot:dhs-h-[40px] dhs-h-[30px] @md/appRoot:dhs-w-[60px] dhs-rounded-lg dhs-text-base dhs-bg-background dhs-cursor-pointer hover:dhs-opacity-90",
              d === -1 && "dhs-opacity-50 hover:dhs-none dhs-cursor-not-allowed",
              l && "dhs-opacity-50 hover:dhs-none dhs-cursor-not-allowed"
            ),
            onClick: () => {
              if (d === -1 || l)
                return h({
                  type: "warning",
                  title: "Slippage not saved",
                  desc: "Please disable Unlimited Slippage or Automatic Slippage to set custom slippage"
                });
              S(!1), c({ target: { value: s } });
            },
            children: /* @__PURE__ */ e(
              "span",
              {
                className: m(
                  "dhs-text-mainText dhs-font-proximaSemiBold",
                  d === parseFloat(s) && "dhs-text-accent"
                ),
                children: s
              }
            )
          },
          s
        )) }),
        /* @__PURE__ */ i("div", { className: "dhs-relative", children: [
          /* @__PURE__ */ e("div", { className: "dhs-absolute dhs-inset-y-0 dhs-text-[16px] dhs-text-mainText dhs-font-proximaSemiBold dhs-right-4 dhs-flex dhs-items-center pointer-events-none", children: "%" }),
          /* @__PURE__ */ e(
            C,
            {
              type: "number",
              value: d,
              className: m(
                "dhs-pl-[15px] dhs-pr-[32px] dhs-border-none dhs-border-transparent focus-visible:dhs-border-transparent focus-visible:ring-0 focus-visible:ring-offset-0 dhs-text-center dhs-bg-background dhs-rounded-lg dhs-w-full dhs-h-[30px] @md/appRoot:dhs-h-[40px] dhs-text-[16px] dhs-text-mainText dhs-font-proximaSemiBold",
                t && "dhs-bg-background"
              ),
              onChange: c,
              disabled: l || !t || d === -1,
              autoFocus: !v && t,
              onKeyDown: w
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e("div", { className: "dhs-flex dhs-justify-between dhs-gap-5 dhs-items-center dhs-pt-3 dhs-pb-2 @md/appRoot:dhs-px-5.5 @md/appRoot:dhs-py-4", children: /* @__PURE__ */ i("div", { className: "dhs-flex dhs-justify-between dhs-w-full dhs-items-center", children: [
      /* @__PURE__ */ e("span", { className: "dhs-text-mainText dhs-font-proximaSemiBold dhs-text-lg dhs-leading-none dhs-flex dhs-flex-col @sm/appRoot:dhs-gap-1", children: /* @__PURE__ */ e("span", { children: "Unlimited Slippage" }) }),
      /* @__PURE__ */ e(
        g,
        {
          left: "OFF",
          right: "ON",
          color: "dhs-bg-red-101",
          className: "dhs-w-[84px] dhs-h-[40px]",
          initValue: d === -1,
          onChange: N
        }
      )
    ] }) })
  ] });
};
export {
  oe as default
};
